module.exports = __webpack_public_path__ + "static/media/fire-testimonial-2.dd266217.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/callouts/fire-testimonial-2.jpg
// module id = 1182
// module chunks = 0